module.exports = __webpack_public_path__ + "img/[左哼哼].28e05282.svg";